/* NOLI theme scripts — no cart, no accounts: tickets go straight to checkout */
(function () {
  'use strict';

  const $ = (sel, root) => (root || document).querySelector(sel);
  const $$ = (sel, root) => Array.from((root || document).querySelectorAll(sel));

  function money(cents) {
    const format = (window.noli && window.noli.moneyFormat) || '£{{amount}}';
    const value = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return format.replace(/\{\{\s*amount[^}]*\}\}/, value);
  }

  /* ---------------------------------------------------------- mobile nav */
  function initNav() {
    const toggle = $('[data-nav-toggle]');
    const nav = $('[data-nav]');
    if (!toggle || !nav || toggle.dataset.bound) return;
    toggle.dataset.bound = '1';

    const scrim = $('[data-nav-scrim]');

    function setOpen(open) {
      nav.classList.toggle('is-open', open);
      if (scrim) scrim.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', String(open));
      document.body.style.overflow = open ? 'hidden' : '';
      if (open) {
        const first = $('a, button', nav);
        if (first) first.focus();
      } else {
        toggle.focus();
      }
    }

    toggle.addEventListener('click', () => setOpen(!nav.classList.contains('is-open')));
    if (scrim) scrim.addEventListener('click', () => setOpen(false));

    const close = $('[data-nav-close]', nav);
    if (close) close.addEventListener('click', () => setOpen(false));

    // Following a link should not leave the drawer open behind the new page.
    $$('a', nav).forEach((link) => link.addEventListener('click', () => setOpen(false)));

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && nav.classList.contains('is-open')) setOpen(false);
    });

    // Resizing past the breakpoint should not strand a hidden drawer + locked scroll.
    window.addEventListener('resize', () => {
      if (window.innerWidth >= 990 && nav.classList.contains('is-open')) setOpen(false);
    });
  }

  /* -------------------------------------------------------- announcement */
  function initAnnouncement() {
    $$('[data-announcement]').forEach((bar) => {
      const key = 'noli-announcement-' + bar.dataset.announcement;
      if (localStorage.getItem(key) === 'closed') {
        bar.hidden = true;
        return;
      }
      const close = $('[data-announcement-close]', bar);
      if (close) {
        close.addEventListener('click', () => {
          bar.hidden = true;
          localStorage.setItem(key, 'closed');
        });
      }
    });
  }

  /* ------------------------------------------------------------------ faq */
  function initFaq() {
    $$('[data-faq-toggle]').forEach((btn) => {
      if (btn.dataset.bound) return;
      btn.dataset.bound = '1';
      btn.addEventListener('click', () => {
        const panel = document.getElementById(btn.getAttribute('aria-controls'));
        const open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!open));
        if (panel) panel.classList.toggle('is-open', !open);
      });
    });
  }

  /* ------------------------------------------------------------ quantity */
  function initQty(root) {
    $$('[data-qty]', root || document).forEach((wrap) => {
      if (wrap.dataset.bound) return;
      wrap.dataset.bound = '1';
      const input = $('input', wrap);
      $$('button', wrap).forEach((btn) => {
        btn.addEventListener('click', () => {
          const step = btn.dataset.qtyChange === 'up' ? 1 : -1;
          const min = parseInt(input.min || '1', 10);
          input.value = Math.max(min, (parseInt(input.value, 10) || min) + step);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* --------------------------------------------- ticket picker + checkout */
  function initTicketPicker() {
    $$('[data-ticket-picker]').forEach((picker) => {
      if (picker.dataset.bound) return;
      picker.dataset.bound = '1';

      const root = picker.closest('[data-product-root]');
      const data = JSON.parse($('[data-variant-json]', picker).textContent);
      const priceEl = $('[data-product-price]', root);
      const buyBtn = $('[data-buy-now]', root);
      const qtyInput = $('[data-qty] input', root);
      const gallery = $('[data-gallery-main]', root);

      function selected() {
        const checked = $$('input:checked', picker).map((i) => i.value);
        return data.find((v) => v.options.every((o, i) => o === checked[i]));
      }

      function update() {
        const variant = selected();
        if (!variant) {
          buyBtn.disabled = true;
          buyBtn.textContent = buyBtn.dataset.unavailable;
          return;
        }
        buyBtn.disabled = !variant.available;
        buyBtn.textContent = variant.available ? buyBtn.dataset.buyLabel : buyBtn.dataset.soldOut;
        buyBtn.dataset.variantId = variant.id;

        if (priceEl) {
          priceEl.innerHTML =
            variant.price === 0
              ? (buyBtn.dataset.freeLabel || 'Free')
              : money(variant.price) +
                (variant.compare_at_price > variant.price ? ' <s>' + money(variant.compare_at_price) + '</s>' : '');
        }
        if (gallery && variant.featured_image) {
          gallery.src = variant.featured_image;
          gallery.srcset = '';
        }
        if (history.replaceState) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          history.replaceState({}, '', url);
        }
      }

      $$('input', picker).forEach((input) => input.addEventListener('change', update));

      if (buyBtn) {
        buyBtn.addEventListener('click', () => {
          const id = buyBtn.dataset.variantId;
          if (!id) return;
          const qty = Math.max(1, parseInt(qtyInput ? qtyInput.value : '1', 10) || 1);
          buyBtn.disabled = true;
          buyBtn.textContent = buyBtn.dataset.loadingLabel || 'Loading…';
          // Cart permalink: replaces any previous basket and jumps straight to checkout.
          window.location.href = window.noli.rootUrl.replace(/\/$/, '') + '/cart/' + id + ':' + qty;
        });
      }

      update();
    });
  }

  /* ------------------------------------------------------------- gallery */
  function initGallery() {
    $$('[data-gallery]').forEach((g) => {
      if (g.dataset.bound) return;
      g.dataset.bound = '1';
      const main = $('[data-gallery-main]', g);
      $$('[data-gallery-thumb]', g).forEach((thumb) => {
        thumb.addEventListener('click', () => {
          main.src = thumb.dataset.galleryThumb;
          main.srcset = '';
          $$('[data-gallery-thumb]', g).forEach((t) => t.setAttribute('aria-current', 'false'));
          thumb.setAttribute('aria-current', 'true');
        });
      });
    });
  }

  /* ------------------------------------------------- shadow-DOM form styling */
  /*
   * The Shopify Forms app renders inside a shadow root, which isolates it from
   * theme.css — external selectors simply never match. The only way to theme it
   * is to push a stylesheet through the boundary, which is what this does.
   * Harmless for form apps that render in the light DOM: nothing is found.
   */
  const SHADOW_FORM_CSS = `
    /*
     * <shopify-forms-embed> is driven entirely by CSS custom properties set on
     * :host. Overriding those is the supported seam — it themes every field,
     * label, border and focus ring at once, and survives the app's hashed class
     * names (_formInputField_nag3b_7 etc.) changing on any release.
     *
     * The block's own settings only reach --body-text-color; the FIELD colours
     * are separate vars it never exposes, which is why the inputs stayed white.
     */
    :host {
      --form-background-color: #0d0d1a !important;
      --form-text-color: #ffffff !important;
      --form-placeholder-color: rgba(255,255,255,0.45) !important;
      --form-field-border: 0 0 0 1px rgba(255,255,255,0.16) !important;
      --form-field-border-focused: 0 0 0 2px #2b8cff !important;
      --form-field-border-radius: 12px !important;
      --form-error-color: #ff8fb0 !important;

      --body-text-color: #ffffff !important;
      --heading-text-color: #ffffff !important;
      --link-text-color: #2b8cff !important;

      --button-text-color: #08000f !important;
      --button-border-radius: 999px !important;
      --container-background-color: transparent !important;
    }

    /* --button-background-color takes a flat colour, so paint the gradient. */
    button[type="submit"], input[type="submit"], [data-testid*="submit" i] {
      background-image: linear-gradient(100deg,#2b8cff,#a855f7 34%,#ff2d95 64%,#ff8a1f) !important;
      text-transform: uppercase !important;
      font-weight: 900 !important;
      letter-spacing: 0.06em !important;
    }

    /* The country/subject pickers are custom buttons, not <select>. */
    [class*="_selectToggle" i] {
      background-color: var(--form-background-color) !important;
      color: var(--form-text-color) !important;
      box-shadow: var(--form-field-border) !important;
      border-radius: var(--form-field-border-radius) !important;
    }

    /*
     * The picker draws its own underline and, once a value is chosen, an
     * outline around the selected text. The field box already comes from
     * --form-field-border on the toggle, so those inner rules read as stray
     * lines. Strip borders/outlines from everything INSIDE the picker and keep
     * the focus ring on the toggle itself.
     */
    [class*="_select" i] hr { display: none !important; }

    [class*="_selectToggle" i] *,
    [class*="_selectContainer" i] > *:not([class*="_selectToggle" i]):not([class*="_selectMenu" i]):not([class*="_selectList" i]) {
      border: 0 !important;
      outline: none !important;
      box-shadow: none !important;
      background-color: transparent !important;
    }

    [class*="_selectToggle" i]:focus,
    [class*="_selectToggle" i]:focus-visible {
      outline: none !important;
      box-shadow: var(--form-field-border-focused) !important;
    }

    /* Their popup list paints on its own layer and needs an opaque fill. */
    [class*="_selectMenu" i], [class*="_selectList" i], [class*="_option" i],
    [role="listbox"], [role="option"] {
      background-color: #12121f !important;
      color: #ffffff !important;
    }

    [class*="_selectMenu" i], [class*="_selectList" i], [role="listbox"] {
      max-height: 200px !important;
      overflow-y: auto !important;
    }

    /*
     * Force the option list to drop DOWNWARDS.
     *
     * The app measures the gap above and below the toggle and simply takes the
     * bigger one (m > c ? showDownwards : showUpwards, in its bundle), so the
     * list flips up and covers the fields above it — which is what it was doing
     * over the table-type dropdown.
     *
     * Crucially it measures inside the FORM, not the viewport:
     *     offsetBottom = form.scrollHeight - toggleTop - toggleHeight
     * "How many tables" sits near the bottom of the form with only the message
     * box and consent below it, so its offsetBottom is small and it flips —
     * while the dropdowns higher up, with more form beneath them, open down
     * normally. That is also why forcing it down is safe: the constraint is the
     * form's own height, not screen space, and there is real room below.
     *
     * These are the app's OWN downward values, lifted from its stylesheet, so
     * flipping the upward variant reproduces its native downward geometry
     * exactly rather than inventing a position:
     *     ._showDownwards { z-index: 4; top: 100%;    left: 0; margin-top: 4px; }
     *     ._showUpwards   { z-index: 4; bottom: 100%; left: 0; margin-bottom: 4px; }
     * Both are absolute inside ._selectContainer, so top:100% clears the label
     * and toggle together. (An earlier note here warned off position overrides;
     * that was before the class names above were known — this targets the
     * direction class itself, not the menu, and leaves the rest of the widget's
     * placement logic untouched.)
     */
    [class*="_dropdownContainer" i][class*="_showUpwards" i] {
      top: 100% !important;
      bottom: auto !important;
      margin-top: 4px !important;
      margin-bottom: 0 !important;
    }

    /*
     * The container carries its own inline max-height sized for whichever gap
     * the app measured, and clips with overflow:hidden. Left alone it can be
     * shorter than the 200px list above and cut the last option off, so hold
     * the two to the same ceiling.
     */
    [class*="_dropdownContainer" i] {
      max-height: 200px !important;
    }

    select option { background-color: #12121f !important; color: #ffffff !important; }
  `;

  function paintShadowRoots(node, depth) {
    if (!node || depth > 14) return;

    if (node.shadowRoot) {
      if (!node.dataset.noliStyled) {
        try {
          var sheet = document.createElement('style');
          sheet.textContent = SHADOW_FORM_CSS;
          node.shadowRoot.appendChild(sheet);
          node.dataset.noliStyled = '1';
        } catch (e) {
          /* closed shadow root — unreachable from here */
        }
      }
      // Always descend, even when this host is already styled: nested shadow
      // roots (the select and phone widgets) mount later than their parent.
      paintShadowRoots(node.shadowRoot, depth + 1);
    }

    var kids = node.children || [];
    for (var i = 0; i < kids.length; i++) paintShadowRoots(kids[i], depth + 1);
  }

  /*
   * Fallback for elements the stylesheet cannot win against — an inline style
   * carrying !important beats an injected sheet, and some widgets set one.
   * Inline styles applied here have the same weight, and being set later they
   * take effect. Only near-white fills are touched, and only to clear them.
   */
  /*
   * Shopify's cookie-consent UI is injected into the page body and is not a
   * form widget, but the colours it ships default to light, so the near-white
   * test below used to strip parts of it to transparent and leave text
   * floating over the page. theme.css restyles the whole thing to the dark
   * surface deliberately — skip the subtree here and let it own the result.
   */
  var CONSENT_SELECTOR = '[id^="shopify-pc__"], [class*="shopify-pc__"]';

  function isConsentUi(el) {
    try {
      return !!(el.closest && el.closest(CONSENT_SELECTOR));
    } catch (e) {
      return false;
    }
  }

  function clearWhiteFills(root, depth) {
    if (!root || depth > 14) return;
    var all = root.querySelectorAll ? root.querySelectorAll('*') : [];
    for (var i = 0; i < all.length; i++) {
      var el = all[i];
      if (el.dataset && el.dataset.noliFill) continue;
      if (isConsentUi(el)) continue;
      var bg;
      try {
        bg = getComputedStyle(el).backgroundColor;
      } catch (e) {
        continue;
      }
      var m = bg && bg.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*([\d.]+))?\)/);
      if (m) {
        var r = +m[1], g = +m[2], b = +m[3], a = m[4] === undefined ? 1 : +m[4];
        // Light and actually painted — the only combination that hurts here.
        if (a > 0.1 && r > 190 && g > 190 && b > 190) {
          el.style.setProperty('background-color', 'transparent', 'important');
          if (el.dataset) el.dataset.noliFill = '1';
        }
      }
      if (el.shadowRoot) clearWhiteFills(el.shadowRoot, depth + 1);
    }
  }

  function initShadowFormStyling() {
    var scan = function () {
      paintShadowRoots(document.body, 0);
      clearWhiteFills(document.body, 0);
    };
    scan();
    // The app mounts asynchronously and can re-render, so keep watching.
    if (window.MutationObserver) {
      var pending = null;
      new MutationObserver(function () {
        clearTimeout(pending);
        pending = setTimeout(scan, 120);
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  /* ------------------------------- vendor form: table type gates table count */
  /*
   * Business rule: Essential and Premium tables can be booked in 1s and 2s
   * only; the 3-table option belongs to Sponsorship. Rather than trust the
   * buyer to read a footnote, the invalid option is removed from the second
   * dropdown while a limited type is selected, and any already-chosen 3 is
   * cleared so it cannot survive into the submission.
   *
   * The form is the Shopify Forms app, so everything here has to work against
   * markup this theme does not own:
   *   - it lives inside a shadow root (see paintShadowRoots above),
   *   - its class names are hashed and change on any app release,
   *   - its dropdowns are custom listboxes, not always native <select>.
   * So fields are found by LABEL TEXT and options by OPTION TEXT — the only
   * two things that are stable because you author them in the app admin. Both
   * the native and the custom rendering are handled.
   *
   * If you reword a label or an option in the Forms app, update the patterns
   * below to match; nothing else in this block needs touching.
   */
  var VENDOR_RULES = {
    typeLabel: /type of table/i,          // "What type of table are you interested in?"
    countLabel: /how many tables/i,       // "How many tables do you want?"
    limitedType: /essential|premium/i,    // these two cannot have 3 tables
    openType: /sponsor/i,                 // sponsorship gets the full list
    restrictedCount: /(^|\D)(3|three)(\D|$)/i, // the option to withhold
  };

  // document + every open shadow root beneath it, so one query covers both.
  function collectRoots(node, depth, out) {
    if (!node || depth > 14) return out;
    if (node.shadowRoot) {
      out.push(node.shadowRoot);
      collectRoots(node.shadowRoot, depth + 1, out);
    }
    var kids = node.children || [];
    for (var i = 0; i < kids.length; i++) collectRoots(kids[i], depth + 1, out);
    return out;
  }

  var CONTROL_SELECTOR =
    'select, [role="combobox"], [role="listbox"], [aria-haspopup="listbox"], [class*="_selectToggle" i]';

  /*
   * Match the label, then walk UP to the smallest ancestor that also contains a
   * control — that ancestor is the field group. Walking up rather than assuming
   * label/control are siblings is what makes this survive the app's layout.
   */
  function findFieldByLabel(roots, re) {
    for (var r = 0; r < roots.length; r++) {
      var els = roots[r].querySelectorAll('label, legend, span, p, div, h1, h2, h3, h4');
      for (var i = 0; i < els.length; i++) {
        var el = els[i];
        var text = (el.textContent || '').trim();
        // Long text means we matched a wrapper, not the label itself.
        if (!text || text.length > 140 || !re.test(text)) continue;
        var node = el;
        for (var up = 0; up < 6 && node; up++) {
          var ctrl = node.querySelector && node.querySelector(CONTROL_SELECTOR);
          if (ctrl) return { root: roots[r], group: node, control: ctrl };
          node = node.parentElement;
        }
      }
    }
    return null;
  }

  // What the field currently reads as — selected <option>, or the toggle's text.
  function fieldText(field) {
    if (!field) return '';
    var c = field.control;
    if (c.tagName === 'SELECT') {
      var o = c.options[c.selectedIndex];
      return o ? (o.textContent || '') : '';
    }
    return c.textContent || '';
  }

  /*
   * The custom widget renders its menu only while open, and may portal it out
   * of the field group, so fall back through: inside the group → the element
   * the toggle owns via aria-controls → the menu that is open right now.
   */
  function optionsOf(field) {
    if (!field) return [];
    if (field.control.tagName === 'SELECT') {
      return Array.prototype.slice.call(field.control.options);
    }
    var MENU = '[role="listbox"], [class*="_selectMenu" i], [class*="_selectList" i]';
    var menu = field.group.querySelector(MENU);
    if (!menu) {
      var owns = field.control.getAttribute && field.control.getAttribute('aria-controls');
      if (owns) menu = field.root.getElementById ? field.root.getElementById(owns) : null;
    }
    if (!menu && field.control.getAttribute && field.control.getAttribute('aria-expanded') === 'true') {
      menu = field.root.querySelector(MENU);
    }
    if (!menu) return [];
    var opts = menu.querySelectorAll('[role="option"], li, [class*="_option" i]');
    return Array.prototype.slice.call(opts);
  }

  function setHidden(el, hide) {
    if (el.tagName === 'OPTION') {
      el.hidden = hide;
      el.disabled = hide; // hidden alone is ignored by some engines
    } else {
      el.style.setProperty('display', hide ? 'none' : '', 'important');
      el.setAttribute('aria-hidden', hide ? 'true' : 'false');
    }
    if (el.dataset) el.dataset.noliTableRule = hide ? 'hidden' : '';
  }

  /*
   * Hiding the option is not enough on its own: a buyer can pick Three under
   * Sponsorship and then switch to Premium, leaving an invalid value that would
   * still submit.
   *
   * The app's dropdown has no placeholder choice to fall back to — the options
   * are exactly One/Two/Three — and its value lives in React state we cannot
   * write to. The only honest way to change it is the widget's own path: open
   * the menu and click a valid option. So the selection drops to the highest
   * still-allowed count (Three becomes Two) rather than emptying, which keeps
   * the field valid and closest to what was asked for. It happens on screen,
   * so the buyer sees the new value.
   */
  var correcting = false;

  function correctInvalidSelection(field) {
    if (correcting) return;
    correcting = true;
    var toggle = field.control;
    var release = function () { correcting = false; };

    if (toggle.getAttribute('aria-expanded') !== 'true') toggle.click();
    // The menu is committed asynchronously, so give the app a frame to render.
    setTimeout(function () {
      var choices = optionsOf(field).filter(function (o) {
        return o.getAttribute
          && o.getAttribute('role') === 'option'
          && (!o.dataset || o.dataset.noliTableRule !== 'hidden');
      });
      var pick = choices[choices.length - 1];
      if (pick) pick.click();
      else if (toggle.getAttribute('aria-expanded') === 'true') toggle.click();
      setTimeout(release, 120);
    }, 180);
  }

  function syncVendorTableRules() {
    var roots = collectRoots(document.body, 0, [document]);
    var type = findFieldByLabel(roots, VENDOR_RULES.typeLabel);
    var count = findFieldByLabel(roots, VENDOR_RULES.countLabel);
    if (!type || !count) return; // not the vendor page, or form not mounted yet

    var typeText = fieldText(type);
    // Only restrict on a definite Essential/Premium reading. An empty or
    // unrecognised type leaves the full list alone, so a matching failure can
    // never silently hide a valid option.
    var restrict = VENDOR_RULES.limitedType.test(typeText) && !VENDOR_RULES.openType.test(typeText);

    /*
     * Only present while the menu is open — the app builds and destroys it on
     * every toggle, so this runs again each time it reopens rather than once.
     */
    var opts = optionsOf(count);
    for (var i = 0; i < opts.length; i++) {
      var text = (opts[i].textContent || '').trim();
      if (!VENDOR_RULES.restrictedCount.test(text)) continue;
      setHidden(opts[i], restrict);
    }

    /*
     * Read the toggle, not the options: the selected value is on screen whether
     * the menu is open or shut, so a stale Three is caught the moment the type
     * changes instead of waiting for the buyer to reopen the list.
     */
    if (restrict && VENDOR_RULES.restrictedCount.test(fieldText(count))) {
      correctInvalidSelection(count);
    }
  }

  /*
   * "Please check" sits above the Instagram consent checkbox and says nothing
   * the checkbox itself doesn't — the tick and its own wording carry the ask.
   * CSS cannot select on text, so the match happens here.
   *
   * Deleting the field label in the Shopify Forms admin is the tidier fix and
   * makes this block redundant; it lives here because the label is authored in
   * the app, not the theme.
   */
  var VENDOR_HIDDEN_LABELS = [/^please check:?$/i];

  function hideVendorLabels() {
    var roots = collectRoots(document.body, 0, [document]);
    for (var r = 0; r < roots.length; r++) {
      var els = roots[r].querySelectorAll('label, legend, span, p, div, h1, h2, h3, h4');
      for (var i = 0; i < els.length; i++) {
        var el = els[i];
        if (el.dataset && el.dataset.noliLabelHidden) continue;
        var text = (el.textContent || '').trim();
        if (!text) continue;

        var match = false;
        for (var p = 0; p < VENDOR_HIDDEN_LABELS.length; p++) {
          if (VENDOR_HIDDEN_LABELS[p].test(text)) { match = true; break; }
        }
        if (!match) continue;

        /*
         * An exact text match already rules out the field wrapper, whose text
         * would include the checkbox's own wording. This is the belt-and-braces
         * half: never hide anything that carries a control with it.
         */
        if (el.querySelector('input, textarea, select, [role="checkbox"]')) continue;

        el.style.setProperty('display', 'none', 'important');
        if (el.dataset) el.dataset.noliLabelHidden = '1';
      }
    }
  }

  function initVendorFormRules() {
    var run = function () {
      try {
        syncVendorTableRules();
        hideVendorLabels();
      } catch (e) {
        /* never let a form tweak take down the rest of theme.js */
      }
    };

    var pending = null;
    var schedule = function () {
      clearTimeout(pending);
      pending = setTimeout(run, 60);
    };

    /*
     * A MutationObserver watching document.body — even with subtree: true —
     * is BLIND to changes inside a shadow root. The option list is created in
     * the app's shadow root each time the dropdown opens, so an observer on
     * body never hears about it. Every shadow root therefore gets its own
     * observer, and new ones are picked up as they mount.
     *
     * childList only, deliberately: this code sets style and data-* on the
     * options it hides, and observing attributes would make it retrigger
     * itself on its own writes.
     */
    var seen = [];
    var watchRoots = function () {
      var roots = collectRoots(document.body, 0, []);
      for (var i = 0; i < roots.length; i++) {
        if (seen.indexOf(roots[i]) > -1) continue;
        seen.push(roots[i]);
        new MutationObserver(schedule).observe(roots[i], { childList: true, subtree: true });
      }
    };

    run();
    if (window.MutationObserver) {
      watchRoots();
      // Hosts mount asynchronously; body churn is the cue to look for new ones.
      new MutationObserver(function () {
        watchRoots();
        schedule();
      }).observe(document.body, { childList: true, subtree: true });
    }

    /*
     * Belt and braces for the open click. The app commits the menu after its
     * own render, so a single setTimeout(0) fires too early — spread a few
     * attempts across the frames where the list realistically appears.
     */
    var burst = function () {
      [0, 60, 150, 300, 600].forEach(function (d) { setTimeout(run, d); });
    };
    document.addEventListener('click', burst, true);
    document.addEventListener('change', run, true);
    document.addEventListener('keyup', burst, true);
  }

  function init() {
    initShadowFormStyling();
    initVendorFormRules();
    initNav();
    initAnnouncement();
    initFaq();
    initQty();
    initTicketPicker();
    initGallery();
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
